import {PageEngineCommands} from "./AddSectionCommand";
import moveElementInArray from "../lib/moveElementInArray";
import {refreshBlockKeyPath} from "../components/v3/lib/vue-dom-obj";

export class SectionRearrangeCommand extends PageEngineCommands {
    constructor(pageEngineComponent, idx, steps) {
        super();
        this._pageEngineComponent = pageEngineComponent
        this._oldIdx = idx
        this._steps = steps
    }

    get hasChanges () {
        return true
    }

    async execute() {
        const currentIdx = this._oldIdx + this._steps
        this.firebaseRef.moveChild(this._oldIdx, this._steps).then (()=> {
            this.clonedVDom = moveElementInArray(this.clonedVDom, this._oldIdx, this._steps)
            // refresh children db paths and keys
            refreshBlockKeyPath(this.clonedVDom[currentIdx].node, currentIdx, this._pageEngineComponent.path())
        })
    }

    async unExecute() {
        const currentIdx = this._oldIdx + this._steps
        const steps = -this._steps
        this.firebaseRef.moveChild(currentIdx, steps).then (()=> {
            this.clonedVDom = moveElementInArray(this.clonedVDom, currentIdx, steps)
            // refresh children db paths and keys
            refreshBlockKeyPath(this.clonedVDom[this._oldIdx].node, this._oldIdx, this._pageEngineComponent.path())
        })
    }
}
